import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../../../services/user.service';
import { WorkflowUtilitiesService } from '../../services/workflow-utilities.service';

/**
 * Main workflow tab manager component.
 */
@Component({
	selector: 'workflow-main',
	templateUrl: './workflow-main.component.html',
	styleUrl: './workflow-main.component.css'
})
export class WorkflowMainComponent implements OnInit, OnDestroy {
	
	private userServiceSubscription!: Subscription;

	LOCALIZATION: any;
	userPermissions: { [key: string]: any } = {};

	ready: boolean = false;

	activeTab: string = 'batches';
	tabs: any[] = [];

	constructor(
		private userService: UserService,
		private dxUtilsService: WorkflowUtilitiesService
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.userPermissions = this.userService.getUserPermissionsMap();
		this.isReady();
	}

	ngOnInit(): void {
		this.userServiceSubscription = this.userService.broadcastEvent.subscribe((eventId: string) => {
			if ("localizationLoaded" === eventId) {
				this.LOCALIZATION = this.userService.LOCALIZATION;
			} else if ("userPrefsUpdate" === eventId) {
				this.userPermissions = this.userService.getUserPermissionsMap();
			}
		});	
		
		this.initTabs();
	}
	
	ngOnDestroy(): void {
		if (this.userServiceSubscription) {
			this.userServiceSubscription.unsubscribe();
		}
	}

	private isReady(): void {
		if (!this.dxUtilsService.enabled) {
			this.ready = false;
			return;
		}

		this.dxUtilsService.getEngineReadyState().then(
			(response: any) => {
				this.ready = true;
			},
			(err: any) => {
				console.error("Failed to get workflow engine status", err);
				this.ready = false;
			}
		);
	}

	private initTabs(): void {
		this.tabs = [{
			id: 'batches',
			title: this.LOCALIZATION?.batches || 'Batches',
			canaccess: (this.userPermissions['ROLE_DECLASS_BATCH_MANAGE'] || this.userPermissions['ROLE_DECLASS_BATCHVIEW']),
			hide: false
		},
		{
			id: 'mytasks',
			title: this.LOCALIZATION?.mytasks || "My Tasks",
			canaccess: (this.userPermissions['ROLE_DECLASS_TASK_MANAGE'] || this.userPermissions['ROLE_DECLASS_TASK_VIEW']),
			hide: false
		},
		{
			id: 'tasks',
			title: this.LOCALIZATION?.availableTasks || "Available Tasks",
			canaccess: (this.userPermissions['ROLE_DECLASS_TASK_MANAGE'] || this.userPermissions['ROLE_DECLASS_TASK_VIEW']),
			hide: false
		},
		{
			id: 'referrals',
			title: this.LOCALIZATION?.referrals || "Referrals",
			canaccess: (this.userPermissions['ROLE_DECLASS_TASK_MANAGE'] || this.userPermissions['ROLE_DECLASS_TASK_VIEW']),
			hide: this.dxUtilsService.getDomainCustomization("main")?.hide?.referrals || false
		}];

		// Deprecated
//		let tabOrder = this.dxUtilsService.getDomainCustomization("main")?.tabOrder || this.tabOrder;
//		for (let i = 0; i <= tabOrder.length; i++) {
//			let tabidx = tabOrder[i];
//			let tab = allTabs.find((x: any) => x.index === tabidx);
//			if (tab) this.tabs.push(tab);
//		}

		this.activeTab = this.tabs[0].id;
	}
}
